import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRequestCancelSubscriptionMutation = createMutationHook(
  MembershipsCreatorApiClient.requestCancelSubscription,
  {
    mutationKey: ['requestCancelSubscription'],
  },
)
